import * as actionTypes from './actionTypes';

export const initUsersStart = () => {
  return {
    type: actionTypes.INIT_USERS_START
  };
};
export const refreshUsers = () => {
  return window.location.reload();
};
export const setUsers = (usersList) => {
  return {
    type: actionTypes.SET_USERS,
    usersList: usersList
  };
};
export const setActiveUser = (user) => {
  return {
    type: actionTypes.SET_ACTIVE_USER,
    activeUser: user
  };
};
export const setFromUserDetailsPage = (value) => {
  return {
    type: actionTypes.SET_FROM_USER_DETAILS_PAGE,
    fromDetailsPage: value
  };
};

export const fetchUsersFailed = () => {
  return {
    type: actionTypes.FETCH_USERS_FAILED
  };
};

export const initUsers = () => {
  return {
    type: actionTypes.INIT_USERS
  };
};

export const getOneUser = (username) => {
  return {
    type: actionTypes.GET_ONE_USER,
    username: username
  };
};
export const getOneUserStart = () => {
  return {
    type: actionTypes.GET_ONE_USER_START
  };
};
export const getOneUserFail = error => {
  return {
    type: actionTypes.GET_ONE_USER_FAIL,
    error: error
  };
};

export const deleteUser = (userId) => {
  return {
    type: actionTypes.DELETE_USERS,
    userId: userId
  };
};

export const editUser = (payload, userId) => {
  return {
    type: actionTypes.EDIT_USERS,
    payload: payload,
    userId: userId
  };
};
export const editUserSuccess = (payload) => {
  return {
    type: actionTypes.EDIT_USERS_SUCCESS,
    payload: payload
  };
};
export const editUserStart = () => {
  return {
    type: actionTypes.EDIT_USERS_START
  };
};
export const editUserFail = error => {
  return {
    type: actionTypes.EDIT_USERS_FAIL,
    error: error
  };
};

export const addUserSuccess = (username, formData) => {
  return {
    type: actionTypes.ADD_USERS_SUCCESS,
    username: username,
    formData: formData
  };
};

export const addUserFail = error => {
  return {
    type: actionTypes.ADD_USERS_FAIL,
    error: error
  };
};

export const addUserStart = () => {
  return {
    type: actionTypes.ADD_USERS_START
  };
};

export const addUser = (formData) => {
  return {
    type: actionTypes.ADD_USERS,
    formData: formData
  };
};

export const addUserInit = () => {
  return {
    type: actionTypes.ADD_USERS_INIT
  };
};
